/**
 * Premium Product Info - Interactive Functionality
 * Handles carousel navigation, variant selection, and sticky ATC
 */

// Simple direct initialization
(function() {
  'use strict';
  
  function initCarousel(section) {
    const mainImage = section.querySelector('.premium-carousel__image');
    const mainContainer = section.querySelector('.premium-carousel__main');
    const thumbnails = section.querySelectorAll('.premium-carousel__thumb');
    
    console.log('Carousel init:', {
      mainImage: mainImage,
      mainContainer: mainContainer,
      thumbnailCount: thumbnails.length
    });
    
    if (!mainImage || !mainContainer || thumbnails.length === 0) {
      console.log('No carousel elements found');
      return;
    }
    
    console.log('Initializing carousel with', thumbnails.length, 'thumbnails');
    
    let currentIndex = 0;
    
    // Touch/swipe variables
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    const minSwipeDistance = 50;
    
    // Function to change image
    function changeToImage(index) {
      console.log('changeToImage called with index:', index);
      if (index < 0 || index >= thumbnails.length) {
        console.log('Index out of bounds');
        return;
      }
      
      const imageUrl = thumbnails[index].getAttribute('data-image-url');
      const imageSrcset = thumbnails[index].getAttribute('data-image-srcset');
      console.log('Changing to image', index, 'URL:', imageUrl);
      
      if (imageUrl && mainImage) {
        // Fade out
        mainImage.style.opacity = '0';
        
        // Change image
        setTimeout(function() {
          mainImage.src = imageUrl;
          if (imageSrcset) {
            mainImage.srcset = imageSrcset;
          }
          
          // Update picture source if it exists
          const pictureElement = mainImage.parentElement;
          if (pictureElement && pictureElement.tagName === 'PICTURE') {
            const sourceElement = pictureElement.querySelector('source[type="image/webp"]');
            if (sourceElement && imageSrcset) {
              sourceElement.srcset = imageSrcset;
            }
          }
          
          mainImage.style.transition = 'opacity 0.3s ease';
          mainImage.style.opacity = '1';
        }, 150);
      }
      
      // Update active states
      thumbnails.forEach(function(t, i) {
        if (i === index) {
          t.classList.add('active');
        } else {
          t.classList.remove('active');
        }
      });
      
      currentIndex = index;
    }
    
    // Add click handler to each thumbnail
    thumbnails.forEach(function(thumb, index) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Thumbnail clicked:', index);
        changeToImage(index);
      });
    });
    
    // Touch event handlers for swipe
    mainContainer.addEventListener('touchstart', function(e) {
      // Don't interfere with zoom button
      if (e.target.closest('.premium-carousel__zoom-btn')) {
        return;
      }
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    mainContainer.addEventListener('touchend', function(e) {
      // Don't interfere with zoom button
      if (e.target.closest('.premium-carousel__zoom-btn')) {
        return;
      }
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeDistanceX = touchEndX - touchStartX;
      const swipeDistanceY = Math.abs(touchEndY - touchStartY);
      
      // Only trigger if horizontal swipe is greater than vertical (to avoid interfering with scroll)
      if (Math.abs(swipeDistanceX) > swipeDistanceY && Math.abs(swipeDistanceX) > minSwipeDistance) {
        if (swipeDistanceX > 0) {
          // Swipe right - go to previous
          const newIndex = currentIndex === 0 ? thumbnails.length - 1 : currentIndex - 1;
          changeToImage(newIndex);
        } else {
          // Swipe left - go to next
          const newIndex = currentIndex === thumbnails.length - 1 ? 0 : currentIndex + 1;
          changeToImage(newIndex);
        }
      }
    }
    
    // Handle clicks on main container based on position (desktop only)
    mainContainer.addEventListener('click', function(e) {
      // Ignore clicks on the zoom button
      if (e.target.closest('.premium-carousel__zoom-btn')) {
        console.log('Zoom button clicked - ignoring carousel navigation');
        return;
      }
      
      // Only use click navigation on non-touch devices
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        console.log('Touch device detected - skipping click navigation');
        return;
      }
      
      console.log('Main container clicked!');
      const rect = this.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const containerWidth = rect.width;
      const clickPercentage = (clickX / containerWidth) * 100;
      
      console.log('Click position:', clickX, 'Width:', containerWidth, 'Percentage:', clickPercentage);
      
      // Left 40% = previous
      if (clickPercentage < 40) {
        console.log('Left side clicked - going to previous');
        const newIndex = currentIndex === 0 ? thumbnails.length - 1 : currentIndex - 1;
        changeToImage(newIndex);
      }
      // Right 40% = next
      else if (clickPercentage > 60) {
        console.log('Right side clicked - going to next');
        const newIndex = currentIndex === thumbnails.length - 1 ? 0 : currentIndex + 1;
        changeToImage(newIndex);
      }
      // Middle 20% = do nothing (or could open lightbox)
      else {
        console.log('Middle clicked - no action');
      }
    });
    
    // Change cursor based on mouse position (desktop only)
    mainContainer.addEventListener('mousemove', function(e) {
      // Skip on touch devices
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        return;
      }
      
      const rect = this.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const containerWidth = rect.width;
      const mousePercentage = (mouseX / containerWidth) * 100;
      
      if (mousePercentage < 40) {
        this.style.cursor = 'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'32\' height=\'32\' viewBox=\'0 0 32 32\'><path d=\'M20 8 L12 16 L20 24\' stroke=\'%23123d07\' stroke-width=\'3\' fill=\'none\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/></svg>") 16 16, pointer';
      } else if (mousePercentage > 60) {
        this.style.cursor = 'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'32\' height=\'32\' viewBox=\'0 0 32 32\'><path d=\'M12 8 L20 16 L12 24\' stroke=\'%23123d07\' stroke-width=\'3\' fill=\'none\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/></svg>") 16 16, pointer';
      } else {
        this.style.cursor = 'pointer';
      }
    });
    
    // Reset cursor when leaving
    mainContainer.addEventListener('mouseleave', function() {
      this.style.cursor = 'pointer';
    });
    
    console.log('Carousel initialization complete');
  }
  
  function initLightbox(section) {
    const zoomBtn = section.querySelector('.premium-carousel__zoom-btn');
    const sectionId = section.getAttribute('data-section-id');
    const lightbox = document.querySelector('#premium-lightbox-' + sectionId);
    
    if (!lightbox) {
      console.log('Lightbox not found for section:', sectionId);
      return;
    }
    
    const lightboxImage = lightbox.querySelector('.premium-lightbox__image');
    const lightboxCounter = lightbox.querySelector('[id^="premium-lightbox-counter"]');
    const closeBtn = lightbox.querySelector('.premium-lightbox__close');
    const prevBtn = lightbox.querySelector('.premium-lightbox__nav--prev');
    const nextBtn = lightbox.querySelector('.premium-lightbox__nav--next');
    const overlay = lightbox.querySelector('.premium-lightbox__overlay');
    const thumbnails = section.querySelectorAll('.premium-carousel__thumb');
    
    if (!zoomBtn || thumbnails.length === 0) {
      console.log('Lightbox elements not found');
      return;
    }
    
    console.log('Initializing lightbox for section:', sectionId);
    
    let currentLightboxIndex = 0;
    
    function openLightbox(index) {
      currentLightboxIndex = index || 0;
      updateLightboxImage();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    function updateLightboxImage() {
      const imageUrl = thumbnails[currentLightboxIndex].getAttribute('data-image-url');
      const imageAlt = thumbnails[currentLightboxIndex].querySelector('img').alt;
      
      if (lightboxImage && imageUrl) {
        lightboxImage.style.opacity = '0';
        setTimeout(function() {
          lightboxImage.src = imageUrl;
          lightboxImage.alt = imageAlt;
          lightboxImage.style.transition = 'opacity 0.3s ease';
          lightboxImage.style.opacity = '1';
        }, 150);
      }
      
      if (lightboxCounter) {
        lightboxCounter.textContent = (currentLightboxIndex + 1) + ' / ' + thumbnails.length;
      }
    }
    
    function goToPrev() {
      currentLightboxIndex = currentLightboxIndex === 0 ? thumbnails.length - 1 : currentLightboxIndex - 1;
      updateLightboxImage();
    }
    
    function goToNext() {
      currentLightboxIndex = currentLightboxIndex === thumbnails.length - 1 ? 0 : currentLightboxIndex + 1;
      updateLightboxImage();
    }
    
    // Open lightbox
    zoomBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.log('Zoom button clicked - opening lightbox');
      
      // Get current image index from main carousel
      const activeThumb = section.querySelector('.premium-carousel__thumb.active');
      const activeIndex = Array.from(thumbnails).indexOf(activeThumb);
      openLightbox(activeIndex >= 0 ? activeIndex : 0);
    });
    
    // Close lightbox
    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', closeLightbox);
    
    // Navigation
    prevBtn.addEventListener('click', goToPrev);
    nextBtn.addEventListener('click', goToNext);
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('active')) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      }
    });
    
    console.log('Lightbox initialized');
  }
  
  function initVariants(section) {
    const variantOptions = section.querySelectorAll('.premium-variant__option');
    const variantIdInput = document.getElementById('premium-variant-id');
    const stickyVariantLabel = document.getElementById('selected-variant-label');
    const stickyVariantPrice = document.getElementById('selected-variant-price');
    const atcButton = section.querySelector('.premium-sticky-atc__button');
    
    // Main price elements
    const mainPrice = section.querySelector('.premium-price__current');
    const comparePrice = section.querySelector('.premium-price__compare');
    
    console.log('Initializing variants:', variantOptions.length, 'options found');
    
    if (variantOptions.length === 0) return;
    
    variantOptions.forEach(function(option, index) {
      console.log('Setting up variant option', index, option);
      
      // Use both click and mousedown for better reliability
      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Variant clicked!', index, this);
        handleVariantSelection(this);
      }, true);
      
      option.addEventListener('mousedown', function(e) {
        e.preventDefault();
        console.log('Variant mousedown!', index);
      });
    });
    
    function handleVariantSelection(button) {
      console.log('handleVariantSelection called', button);
      
      if (button.disabled) {
        console.log('Variant is disabled');
        return;
      }
      
      // Remove active from all options in the same group
      const group = button.closest('.premium-variant-group');
      group.querySelectorAll('.premium-variant__option').forEach(function(opt) {
        opt.classList.remove('active');
      });
      
      // Add active to clicked option
      button.classList.add('active');
      
      // Update hidden input
      const variantId = button.dataset.variantId;
      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }
      
      // Get variant data
      const variantValue = button.querySelector('.premium-variant__value')?.textContent;
      const variantPrice = button.dataset.variantPrice;
      const variantCompare = button.dataset.variantCompare;
      
      console.log('Updating prices:', variantPrice, variantCompare);
      
      // Update main price display
      if (mainPrice && variantPrice) {
        mainPrice.textContent = variantPrice;
      }
      
      // Update compare price
      if (comparePrice && variantCompare && variantCompare !== 'null' && variantCompare !== '') {
        comparePrice.textContent = variantCompare;
        comparePrice.style.display = '';
      } else if (comparePrice) {
        comparePrice.style.display = 'none';
      }
      
      // Update sticky bar price only (not the label/title)
      if (stickyVariantPrice && variantPrice) {
        stickyVariantPrice.textContent = variantPrice;
      }
      
      // Enable ATC button
      if (atcButton) {
        atcButton.disabled = false;
      }
      
      // Sync with sticky dropdown
      const stickySelect = document.getElementById('premium-sticky-variant-select');
      if (stickySelect && variantId) {
        stickySelect.value = variantId;
      }
    }
  }
  
  function initShare(section) {
    const shareBtn = section.querySelector('.premium-info__share');
    
    if (!shareBtn) return;
    
    shareBtn.addEventListener('click', async function() {
      const shareData = {
        title: document.querySelector('.premium-info__title')?.textContent || 'Check out this product',
        text: document.querySelector('.premium-info__description')?.textContent || '',
        url: window.location.href
      };
      
      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else {
          await navigator.clipboard.writeText(window.location.href);
          showShareFeedback(shareBtn);
        }
      } catch (err) {
        console.log('Share failed:', err);
      }
    });
  }
  
  function showShareFeedback(button) {
    const originalHTML = button.innerHTML;
    button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    button.style.background = '#123d07';
    button.style.color = '#fff';
    
    setTimeout(function() {
      button.innerHTML = originalHTML;
      button.style.background = '';
      button.style.color = '';
    }, 2000);
  }
  
  function initStickyATC(section) {
    const stickyBar = section.querySelector('.premium-sticky-atc');
    const form = section.querySelector('.premium-sticky-atc__form');
    
    if (!stickyBar) return;
    
    // Use global cart state if available (from card-variants.js)
    const CartState = window.CartState || {
      cache: null,
      listeners: new Set(),
      async fetch(force = false) {
        if (this.cache && !force) return this.cache;
        try {
          const res = await fetch("/cart.js");
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          this.cache = await res.json();
          return this.cache;
        } catch (err) {
          console.error('Error fetching cart:', err);
          return { items: [], item_count: 0, total_price: 0 };
        }
      },
      async update(force = true) {
        const cart = await this.fetch(force);
        this.notify(cart);
        return cart;
      },
      notify(cart) {
        this.listeners.forEach(callback => callback(cart));
      },
      subscribe(callback) {
        this.listeners.add(callback);
        return () => this.listeners.delete(callback);
      }
    };
    
    // Make it globally available
    if (!window.CartState) {
      window.CartState = CartState;
    }
    
    async function getCart(force = false) {
      return CartState.fetch(force);
    }
    
    function updateCartBubble(count) {
      const bubble = document.querySelector(".header__icon--cart .cart-count-bubble");
      if (bubble) {
        bubble.textContent = count;
      } else {
        const cartIcon = document.querySelector(".header__icon--cart");
        if (cartIcon) {
          const newBubble = document.createElement("div");
          newBubble.className = "cart-count-bubble flo-cart-icon-bubble";
          newBubble.textContent = count;
          cartIcon.appendChild(newBubble);
        }
      }
    }
    
    function debounce(fn, delay) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(function() { fn.apply(this, args); }, delay);
      };
    }
    
    function showQuantitySelector(variantId, quantity = 1) {
      const atcButton = form.querySelector('.premium-sticky-atc__button');
      if (!atcButton) return;
      
      // Check if quantity selector already exists
      let qtyEl = form.querySelector('.premium-sticky-quantity');
      if (qtyEl) {
        // Just update the value
        const input = qtyEl.querySelector('.premium-quantity__input');
        if (input) input.value = quantity;
        return;
      }
      
      // Hide ATC button
      atcButton.style.display = 'none';
      
      // Create quantity selector
      qtyEl = document.createElement('div');
      qtyEl.className = 'premium-sticky-quantity';
      qtyEl.innerHTML = `
        <button class="premium-quantity__button premium-quantity__minus" type="button" aria-label="Decrease quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
        <input class="premium-quantity__input" type="number" min="0" value="${quantity}" aria-label="Quantity">
        <button class="premium-quantity__button premium-quantity__plus" type="button" aria-label="Increase quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      `;
      
      atcButton.insertAdjacentElement('afterend', qtyEl);
      
      const minusBtn = qtyEl.querySelector('.premium-quantity__minus');
      const plusBtn = qtyEl.querySelector('.premium-quantity__plus');
      const input = qtyEl.querySelector('.premium-quantity__input');
      
      async function updateCartQuantity(newQty) {
        if (newQty < 0) newQty = 0;
        
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: { [variantId]: newQty } })
          });
          const cart = await res.json();
          input.value = newQty;
          updateCartBubble(cart.item_count);
          
          // Update global cart state and notify all listeners
          CartState.cache = cart;
          CartState.notify(cart);
          
          // Notify Shopflo
          if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') {
            window.Shopflo.refreshCart();
          }
          
          // Trigger custom event
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { cart: cart } 
          }));
          
          if (newQty <= 0) {
            qtyEl.remove();
            atcButton.style.display = 'flex';
            atcButton.disabled = false;
            // Restore original button content
            atcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        } catch (err) {
          console.error('Cart update error:', err);
        }
      }
      
      minusBtn.addEventListener('click', function() {
        updateCartQuantity(parseInt(input.value) - 1);
      });
      
      plusBtn.addEventListener('click', function() {
        updateCartQuantity(parseInt(input.value) + 1);
      });
      
      input.addEventListener('change', debounce(function() {
        updateCartQuantity(parseInt(input.value) || 0);
      }, 300));
    }
    
    // Show/hide based on scroll
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 300) {
        stickyBar.style.transform = 'translateY(0)';
      } else {
        stickyBar.style.transform = 'translateY(100%)';
      }
    });
    
    // Form submission
    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const atcButton = form.querySelector('.premium-sticky-atc__button');
        
        if (!variantId) {
          alert('Please select a variant');
          return;
        }
        
        if (atcButton) {
          atcButton.disabled = true;
          atcButton.innerHTML = '<span>Adding...</span>';
        }
        
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          
          const addedItem = await res.json();
          
          // Show quantity selector
          showQuantitySelector(addedItem.variant_id, addedItem.quantity);
          
          // Update cart bubble and notify
          const cart = await CartState.update(true);
          updateCartBubble(cart.item_count);
          
          // Notify Shopflo
          if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') {
            window.Shopflo.refreshCart();
          }
          
          // Trigger custom event
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { cart: cart } 
          }));
          
          // Show success message briefly
          showAddToCartSuccess(section);
          
        } catch (error) {
          console.error('Error adding to cart:', error);
          showAddToCartError(section);
          
          if (atcButton) {
            atcButton.disabled = false;
            atcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        }
      });
    }
    
    // Check on load if variant is already in cart
    const variantSelect = form.querySelector('select[name="id"]');
    const variantInput = form.querySelector('input[name="id"]');
    const currentVariantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : null);
    
    function syncStickyWithCart(variantId) {
      const cart = CartState.cache;
      if (!cart) return;
      
      const lineItem = cart.items.find(function(item) {
        return item.variant_id == variantId;
      });
      
      const qtyEl = form.querySelector('.premium-sticky-quantity');
      const atcButton = form.querySelector('.premium-sticky-atc__button');
      
      if (lineItem) {
        if (!qtyEl) {
          showQuantitySelector(lineItem.variant_id, lineItem.quantity);
        } else {
          const qtyInput = qtyEl.querySelector('.premium-quantity__input');
          if (qtyInput && parseInt(qtyInput.value) !== lineItem.quantity) {
            qtyInput.value = lineItem.quantity;
          }
        }
      } else {
        if (qtyEl) {
          qtyEl.remove();
          if (atcButton) {
            atcButton.style.display = 'flex';
            atcButton.disabled = false;
            atcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        }
      }
      
      updateCartBubble(cart.item_count);
    }
    
    if (currentVariantId) {
      getCart().then(function(cart) {
        const lineItem = cart.items.find(function(item) {
          return item.variant_id == currentVariantId;
        });
        
        if (lineItem) {
          showQuantitySelector(lineItem.variant_id, lineItem.quantity);
        }
        
        updateCartBubble(cart.item_count);
      });
    }
    
    // Subscribe to cart updates (event-driven)
    const unsubscribe = CartState.subscribe(function(cart) {
      const currentVariantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : null);
      if (currentVariantId) {
        syncStickyWithCart(currentVariantId);
      }
    });
    
    // Listen for external cart refresh events
    document.addEventListener('cart:refresh', async function() {
      await CartState.update(true);
    });
    
    // Listen for variant changes from main selector
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        const newVariantId = this.value;
        syncStickyWithCart(newVariantId);
      });
    }
  }
  
  function showAddToCartSuccess(section) {
    const button = section.querySelector('.premium-sticky-atc__button');
    if (!button) return;
    
    const originalHTML = button.innerHTML;
    button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg><span>Added to Cart!</span>';
    button.style.background = '#0d2d05';
    
    setTimeout(function() {
      button.innerHTML = originalHTML;
      button.style.background = '';
    }, 2500);
  }
  
  function showAddToCartError(section) {
    const button = section.querySelector('.premium-sticky-atc__button');
    if (!button) return;
    
    const originalHTML = button.innerHTML;
    button.innerHTML = '<span>Error - Try Again</span>';
    button.style.background = '#c41e3a';
    
    setTimeout(function() {
      button.innerHTML = originalHTML;
      button.style.background = '';
    }, 2500);
  }
  
  // Initialize all sections
  function init() {
    console.log('Premium Product Info: Initializing...');
    const sections = document.querySelectorAll('.premium-product-section');
    console.log('Found', sections.length, 'premium product sections');
    
    sections.forEach(function(section) {
      console.log('Setting up section:', section);
      initCarousel(section);
      initLightbox(section);
      initVariants(section);
      initShare(section);
      initStickyATC(section);
      initDeliveryChecker(section);
      initStickyVariantSelect(section);
      initMobileStickyATC(section);
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Add sticky bar animation styles
  const style = document.createElement('style');
  style.textContent = `
    @keyframes pulse {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-5px); }
    }
    
    .premium-sticky-atc {
      transform: translateY(100%);
      transition: transform 0.3s ease;
    }
  `;
  document.head.appendChild(style);
  
})();


  function initDeliveryChecker(section) {
    const pincodeInput = document.getElementById('premium-pincode');
    const checkButton = document.getElementById('premium-check-delivery');
    const resultDiv = document.getElementById('premium-delivery-result');
    
    if (!pincodeInput || !checkButton || !resultDiv) {
      console.log('Delivery checker elements not found');
      return;
    }
    
    checkButton.addEventListener('click', function() {
      const pincode = pincodeInput.value.trim();
      
      // Validate pincode
      if (!pincode || pincode.length !== 6 || !/^\d{6}$/.test(pincode)) {
        showResult('error', 'Please enter a valid 6-digit PIN code');
        return;
      }
      
      // Show loading state
      checkButton.textContent = 'Checking...';
      checkButton.disabled = true;
      
      // Simulate API call (replace with your actual delivery check API)
      setTimeout(function() {
        // Example: Check if pincode is serviceable
        // Replace this with your actual logic
        const isServiceable = checkPincodeServiceability(pincode);
        
        if (isServiceable) {
          const deliveryDate = getEstimatedDeliveryDate();
          showResult('success', `✓ Delivery available! Estimated delivery by ${deliveryDate}`);
        } else {
          showResult('error', '✗ Sorry, delivery not available for this PIN code');
        }
        
        checkButton.textContent = 'Check';
        checkButton.disabled = false;
      }, 1000);
    });
    
    // Allow Enter key to trigger check
    pincodeInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        checkButton.click();
      }
    });
    
    function showResult(type, message) {
      resultDiv.className = 'premium-delivery__result ' + type;
      resultDiv.textContent = message;
    }
    
    function checkPincodeServiceability(pincode) {
      // Replace with your actual serviceability check logic
      // This is just a demo - returns true for most pincodes
      const firstDigit = parseInt(pincode.charAt(0));
      return firstDigit >= 1 && firstDigit <= 8; // Example logic
    }
    
    function getEstimatedDeliveryDate() {
      const today = new Date();
      const deliveryDays = 3; // Adjust based on your logic
      const deliveryDate = new Date(today.setDate(today.getDate() + deliveryDays));
      
      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      return deliveryDate.toLocaleDateString('en-IN', options);
    }
    
    console.log('Delivery checker initialized');
  }


  function initStickyVariantSelect(section) {
    const stickySelect = document.getElementById('premium-sticky-variant-select');
    const mainPrice = section.querySelector('.premium-price__current');
    const comparePrice = section.querySelector('.premium-price__compare');
    const stickyPrice = document.getElementById('selected-variant-price');
    const stickyLabel = document.getElementById('selected-variant-label');
    const variantOptions = section.querySelectorAll('.premium-variant__option');
    
    if (!stickySelect) {
      console.log('Sticky variant select not found');
      return;
    }
    
    console.log('Initializing sticky variant select');
    
    // Update when sticky dropdown changes
    stickySelect.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const variantId = this.value;
      const variantText = selectedOption.textContent.split(' - ')[0];
      const variantPrice = selectedOption.textContent.split(' - ')[1].split(' (')[0];
      
      console.log('Sticky select changed:', variantId, variantText, variantPrice);
      
      // Update sticky bar price only (keep product title)
      if (stickyLabel) {
        // Don't update - keep product title
        // stickyLabel.textContent = variantText;
      }
      
      if (stickyPrice) {
        stickyPrice.textContent = variantPrice;
      }
      
      // Update main price display
      if (mainPrice) {
        mainPrice.textContent = variantPrice;
      }
      
      // Update main variant buttons
      variantOptions.forEach(function(option) {
        if (option.dataset.variantId === variantId) {
          // Remove active from all
          variantOptions.forEach(function(opt) {
            opt.classList.remove('active');
          });
          // Add active to matching
          option.classList.add('active');
          
          // Update compare price if exists
          const variantCompare = option.dataset.variantCompare;
          if (comparePrice && variantCompare && variantCompare !== 'null' && variantCompare !== '') {
            comparePrice.textContent = variantCompare;
            comparePrice.style.display = '';
          } else if (comparePrice) {
            comparePrice.style.display = 'none';
          }
        }
      });
    });
    
    console.log('Sticky variant select initialized');
  }


  function initMobileStickyATC(section) {
    const sectionId = section.getAttribute('data-section-id');
    const mobileStickyBar = document.getElementById('mobile-sticky-atc-' + sectionId);
    const mobileAtcButton = document.getElementById('mobile-atc-button-' + sectionId);
    const variantButtons = mobileStickyBar ? mobileStickyBar.querySelectorAll('.premium-sticky-atc-mobile__variant') : [];
    
    // Main page elements
    const mainVariantOptions = section.querySelectorAll('.premium-variant__option');
    const mainPrice = section.querySelector('.premium-price__current');
    const comparePrice = section.querySelector('.premium-price__compare');
    
    if (!mobileStickyBar || !mobileAtcButton) {
      console.log('Mobile sticky ATC not found');
      return;
    }
    
    console.log('Initializing mobile sticky ATC');
    
    let selectedVariantId = null;
    
    // Set initial variant
    const activeVariant = mobileStickyBar.querySelector('.premium-sticky-atc-mobile__variant.active');
    if (activeVariant) {
      selectedVariantId = activeVariant.getAttribute('data-variant-id');
    }
    
    // Show/hide based on scroll
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 300) {
        mobileStickyBar.classList.add('visible');
      } else {
        mobileStickyBar.classList.remove('visible');
      }
    });
    
    // Handle variant selection
    variantButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        if (this.disabled) return;
        
        // Remove active from all mobile variants
        variantButtons.forEach(function(btn) {
          btn.classList.remove('active');
        });
        
        // Add active to clicked
        this.classList.add('active');
        
        // Update selected variant
        selectedVariantId = this.getAttribute('data-variant-id');
        
        // Enable ATC button
        mobileAtcButton.disabled = false;
        
        console.log('Mobile variant selected:', selectedVariantId);
        
        // Sync with main variant selectors and update prices
        mainVariantOptions.forEach(function(option) {
          if (option.getAttribute('data-variant-id') === selectedVariantId) {
            // Remove active from all main variants
            mainVariantOptions.forEach(function(opt) {
              opt.classList.remove('active');
            });
            
            // Add active to matching variant
            option.classList.add('active');
            
            // Update main price
            const variantPrice = option.getAttribute('data-variant-price');
            const variantCompare = option.getAttribute('data-variant-compare');
            
            if (mainPrice && variantPrice) {
              mainPrice.textContent = variantPrice;
            }
            
            // Update compare price
            if (comparePrice && variantCompare && variantCompare !== 'null' && variantCompare !== '') {
              comparePrice.textContent = variantCompare;
              comparePrice.style.display = '';
            } else if (comparePrice) {
              comparePrice.style.display = 'none';
            }
          }
        });
      });
    });
    
    // Listen for main variant changes and sync to mobile sticky
    mainVariantOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        const variantId = this.getAttribute('data-variant-id');
        
        // Update mobile sticky variants
        variantButtons.forEach(function(btn) {
          if (btn.getAttribute('data-variant-id') === variantId) {
            variantButtons.forEach(function(b) { b.classList.remove('active'); });
            btn.classList.add('active');
            selectedVariantId = variantId;
          }
        });
      });
    });
    
    // Handle add to cart
    mobileAtcButton.addEventListener('click', async function() {
      if (!selectedVariantId) {
        alert('Please select a variant');
        return;
      }
      
      this.disabled = true;
      this.innerHTML = '<span>Adding...</span>';
      
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
        });
        
        const addedItem = await res.json();
        
        // Show quantity selector instead of just success message
        showMobileQuantitySelector(mobileStickyBar, addedItem.variant_id, mobileAtcButton, addedItem.quantity);
        
        // Update cart and notify
        if (window.CartState) {
          const cart = await window.CartState.update(true);
          const bubble = document.querySelector(".header__icon--cart .cart-count-bubble");
          if (bubble) {
            bubble.textContent = cart.item_count;
          }
        } else {
          const cart = await fetch('/cart.js').then(function(r) { return r.json(); });
          const bubble = document.querySelector(".header__icon--cart .cart-count-bubble");
          if (bubble) {
            bubble.textContent = cart.item_count;
          }
        }
        
        // Notify Shopflo
        if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') {
          window.Shopflo.refreshCart();
        }
        
        // Trigger custom event
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: addedItem } 
        }));
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.innerHTML = '<span>Error - Try Again</span>';
        this.disabled = false;
        
        setTimeout(function() {
          mobileAtcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        }, 2000);
      }
    });
    
    // Function to show quantity selector for mobile
    function showMobileQuantitySelector(container, variantId, addBtn, quantity = 1) {
      // Check if quantity selector already exists
      let qtyEl = container.querySelector('.mobile-quantity-selector');
      if (qtyEl) {
        // Just update the value
        const input = qtyEl.querySelector('.mobile-quantity__input');
        if (input) input.value = quantity;
        return;
      }
      
      // Hide ATC button
      addBtn.style.display = 'none';
      
      // Create quantity selector
      qtyEl = document.createElement('div');
      qtyEl.className = 'mobile-quantity-selector';
      qtyEl.innerHTML = `
        <button class="mobile-quantity__button mobile-quantity__minus" type="button" aria-label="Decrease quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
        <input class="mobile-quantity__input" type="number" min="0" value="${quantity}" aria-label="Quantity">
        <button class="mobile-quantity__button mobile-quantity__plus" type="button" aria-label="Increase quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      `;
      
      addBtn.insertAdjacentElement('afterend', qtyEl);
      
      const minusBtn = qtyEl.querySelector('.mobile-quantity__minus');
      const plusBtn = qtyEl.querySelector('.mobile-quantity__plus');
      const input = qtyEl.querySelector('.mobile-quantity__input');
      
      async function updateMobileCartQuantity(newQty) {
        if (newQty < 0) newQty = 0;
        
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: { [variantId]: newQty } })
          });
          const cart = await res.json();
          input.value = newQty;
          
          // Update global cart state if available
          if (window.CartState) {
            window.CartState.cache = cart;
            window.CartState.notify(cart);
          }
          
          // Notify Shopflo
          if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') {
            window.Shopflo.refreshCart();
          }
          
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { cart: cart } 
          }));
          
          // Update cart bubble
          const bubble = document.querySelector(".header__icon--cart .cart-count-bubble");
          if (bubble) {
            bubble.textContent = cart.item_count;
          }
          
          if (newQty <= 0) {
            qtyEl.remove();
            addBtn.style.display = 'flex';
            addBtn.disabled = false;
            addBtn.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        } catch (err) {
          console.error('Mobile cart update error:', err);
        }
      }
      
      minusBtn.addEventListener('click', function() {
        updateMobileCartQuantity(parseInt(input.value) - 1);
      });
      
      plusBtn.addEventListener('click', function() {
        updateMobileCartQuantity(parseInt(input.value) + 1);
      });
      
      input.addEventListener('change', function() {
        updateMobileCartQuantity(parseInt(input.value) || 0);
      });
    }
    
    // Check on load if variant is already in cart
    if (selectedVariantId) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          const lineItem = cart.items.find(function(item) {
            return item.variant_id == selectedVariantId;
          });
          
          if (lineItem) {
            showMobileQuantitySelector(mobileStickyBar, lineItem.variant_id, mobileAtcButton, lineItem.quantity);
          }
        })
        .catch(function(err) {
          console.error('Error checking cart on load:', err);
        });
    }
    
    // Subscribe to cart updates (event-driven) if CartState is available
    if (window.CartState) {
      const unsubscribe = window.CartState.subscribe(function(cart) {
        if (!selectedVariantId) return;
        
        const lineItem = cart.items.find(function(item) {
          return item.variant_id == selectedVariantId;
        });
        
        const qtyEl = mobileStickyBar.querySelector('.mobile-quantity-selector');
        
        if (lineItem) {
          if (!qtyEl) {
            showMobileQuantitySelector(mobileStickyBar, lineItem.variant_id, mobileAtcButton, lineItem.quantity);
          } else {
            const qtyInput = qtyEl.querySelector('.mobile-quantity__input');
            if (qtyInput && parseInt(qtyInput.value) !== lineItem.quantity) {
              qtyInput.value = lineItem.quantity;
            }
          }
        } else {
          if (qtyEl) {
            qtyEl.remove();
            mobileAtcButton.style.display = 'flex';
            mobileAtcButton.disabled = false;
            mobileAtcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        }
      });
    }
    
    // Listen for external cart refresh events
    document.addEventListener('cart:refresh', async function() {
      if (window.CartState) {
        await window.CartState.update(true);
      }
    });
    
    // Listen for variant changes
    variantButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const newVariantId = this.getAttribute('data-variant-id');
        selectedVariantId = newVariantId;
        
        // Sync with cart state
        if (window.CartState && window.CartState.cache) {
          const cart = window.CartState.cache;
          const lineItem = cart.items.find(function(item) {
            return item.variant_id == newVariantId;
          });
          
          const qtyEl = mobileStickyBar.querySelector('.mobile-quantity-selector');
          
          if (lineItem) {
            showMobileQuantitySelector(mobileStickyBar, lineItem.variant_id, mobileAtcButton, lineItem.quantity);
          } else {
            if (qtyEl) qtyEl.remove();
            mobileAtcButton.style.display = 'flex';
            mobileAtcButton.disabled = false;
            mobileAtcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        }
      });
    });
    
    console.log('Mobile sticky ATC initialized');
  }
